/* eslint-disable @typescript-eslint/no-unused-expressions */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { findIndex } from 'lodash';

const initialState = {
  list_payment: {
    payment_methods: [],
  } as any,
  select_payment: {} as any,
  page: 1,
};

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    requestPayments: (_state, _action: PayloadAction<{ page?: number; limit?: number }>) => {},
    savePayments: (state, action: PayloadAction<{ data: any }>) => {
      const { data } = action.payload;
      state.list_payment = data;
    },
    clearPaymentInList: (state, { payload: { id } }: PayloadAction<{ id: string }>) => {
      const index = findIndex(state.list_payment.payment_methods, { id });
      state.list_payment.payment_methods.splice(index, 1);
    },
    selectPayment: (state, action: PayloadAction<{ data: any }>) => {
      state.select_payment = action.payload.data;
    },
    resetPayments: (state, _action: PayloadAction) => {
      return Object.assign(state, initialState);
    },
    deletePayment: (_state, _action: PayloadAction<{ data: any }>) => undefined,
  },
});

export default paymentSlice;
